<template>
  <div class="ee-card-attribute input">
    <r-text type="caption">
      {{ config.label }}
    </r-text>
    <el-input
      class="r-input"
      size="mini"
      v-model="feature[config.prop]"
      :disabled="config.disabled"
    />
  </div>
</template>

<script>
export default {
  props: ["feature", "config"]
};
</script>

<style></style>
